import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface ModalReopenQuoteProps extends ModalEditComponentProps {}

const ModalReopenQuote: React.FC<ModalReopenQuoteProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept, loading } = useModalReopenQuoteLogic({ setOpened, onSubmit, allRowData })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleOnAccept} translations={{
            title: t('sureReopenQuote', '¿Seguro que quieres reabrir este presupuesto?'),
            subtitle: t('modificableOnceReopened', 'Podrás modificar datos una vez reabierto'),
            buttonAccept: t('accept', 'Aceptar'),
        }} loading={loading} />
    )
}

interface ModalReopenQuoteLogicProps extends ModalEditComponentProps { }

const useModalReopenQuoteLogic = ({ allRowData, onSubmit }: ModalReopenQuoteLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const handleOnAccept = useCallback(async () => {
        startLoading?.()
        const result = await twinFetchPostJSON('/api/app/order/quote/transformQuoteToNewQuoteOrderVersion', { ...allRowData || {} })
        if (result) {
            onSubmit?.(result, {})
        }
        endLoading?.()
    }, [startLoading, endLoading, onSubmit, allRowData])
    return { handleOnAccept, loading }
}


export default ModalReopenQuote